import React, { useCallback, useEffect, useState } from "react";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { RotateCcw, ShieldOff, Gauge, ServerCrash } from "lucide-react";

const ICON = {
  auto_block_ip: ShieldOff,
  rate_limit: Gauge,
  rule_rollback: RotateCcw,
  isolate_host: ServerCrash,
};

export default function SelfHealing() {
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/self-healing/actions", { params: { limit: 200 } });
      setItems(data);
    } catch (err) {
      console.error("healing load failed", err);
    }
  }, []);
  useEffect(() => {
    load();
    const i = setInterval(load, 5000);
    return () => clearInterval(i);
  }, [load]);

  const grouped = items.reduce((a, h) => { a[h.type] = (a[h.type] || 0) + 1; return a; }, {});

  return (
    <Layout title="Self-Healing" subtitle="REMEDIATION">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        {["auto_block_ip", "rate_limit", "rule_rollback", "isolate_host"].map((t) => {
          const I = ICON[t] || RotateCcw;
          return (
            <div key={t} data-testid={`heal-stat-${t}`} className="border border-zinc-800 bg-zinc-900/60 rounded-sm p-4 fade-up">
              <div className="flex items-center justify-between">
                <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500">{t.replace(/_/g, " ")}</div>
                <I className="w-4 h-4 text-amber-400" />
              </div>
              <div className="font-display text-3xl font-bold tabular-nums mt-2">{grouped[t] || 0}</div>
            </div>
          );
        })}
      </div>

      <div className="border border-zinc-800 rounded-sm bg-zinc-900/40">
        <div className="px-4 py-3 border-b border-zinc-800 flex items-center justify-between">
          <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-400">REMEDIATION TIMELINE</div>
          <span className="text-[10px] font-mono text-amber-400 flex items-center gap-2"><span className="live-dot amber" /> AUTO-MITIGATING</span>
        </div>
        <div className="divide-y divide-zinc-800/70" data-testid="healing-list">
          {items.map((h) => {
            const I = ICON[h.type] || RotateCcw;
            return (
              <div key={h.action_id} className="px-4 py-3 grid grid-cols-12 gap-3 items-center font-mono text-[11px]">
                <div className="col-span-2 text-zinc-500">{h.timestamp.slice(11, 19)}</div>
                <div className="col-span-3 flex items-center gap-2">
                  <I className="w-3.5 h-3.5 text-amber-400" />
                  <span className="text-amber-400 uppercase tracking-widest">{h.type}</span>
                </div>
                <div className="col-span-3 text-cyan-400">{h.target}</div>
                <div className="col-span-2 text-zinc-300 whitespace-normal break-words">{h.reason}</div>
                <div className="col-span-1 uppercase text-zinc-400">{h.cloud}</div>
                <div className="col-span-1 text-right">
                  <span className="px-1.5 py-0.5 border rounded-sm border-emerald-500/40 bg-emerald-500/10 text-emerald-400 uppercase tracking-widest text-[10px]">{h.status}</span>
                </div>
              </div>
            );
          })}
          {items.length === 0 && <div className="text-zinc-500 text-sm font-mono px-4 py-10 text-center">no remediation actions yet.</div>}
        </div>
      </div>
    </Layout>
  );
}
